<template>
  <div class="bg-white h-screen w-screen flex flex-row items-center justify-center relative">
    <div class="hidden lg:flex w-2/5 mr-24">
      <video width="100%" loop autoplay muted playsinline src="/welcome.mp4"></video>
    </div>
    <div class="flex flex-col">
      <div v-if="loginStatus === 'success'" class="flex flex-col items-center">
        <div class="text-sm text-grey-darker mb-8">Mohon bersabar, memuat aplikasi... :)</div>
        <v-icon scale="2" class="self-center text-grey-dark" name="spinner" pulse />
      </div>
      <form v-else class="flex flex-col items-center justify-center bg-brand-light p-8 rounded-lg" @submit.prevent="login">
        <div class="text-brand text-2xl font-bold mb-6">Analisis GTK</div>
        <!-- <div class="text-black my-2">Masuk</div> -->
        <div class="text-xs text-danger w-48 my-2" v-if="loginStatus === 'error'">Gagal masuk aplikasi. {{ errorMessage }}</div>
        <div class="flex flex-col my-2">
          <label class="mb-1 text-grey-darkest text-xs" for="username">Username</label>
          <input id="username" required v-model="username" type="text" placeholder="Username" class="bg-grey-lightest outline-none rounded p-2" :class="{ 'opacity-50 cursor-not-allowed': loginStatus === 'loading' }" :disabled="loginStatus === 'loading'">
        </div>
        <div class="flex flex-col my-2">
          <label class="mb-1 text-grey-darkest text-xs" for="password">Password</label>
          <input id="password" required v-model="password" type="password" placeholder="Password" class="bg-grey-lightest outline-none rounded p-2" :class="{ 'opacity-50 cursor-not-allowed': loginStatus === 'loading' }" :disabled="loginStatus === 'loading'">
        </div>
        <hr/>
        <button class="bg-brand hover:bg-brand-dark text-white w-24 h-8 font-bold py-1 px-2 rounded flex items-center justify-center" type="submit" :class="{ 'opacity-50 cursor-not-allowed': loginStatus === 'loading' }" :disabled="loginStatus === 'loading'">
          <div v-if="loginStatus === 'loading'" class="flex">
            <v-icon scale="1" class="self-center text-white" name="spinner" pulse />
          </div>
          <div v-else>
            Masuk
          </div>
        </button>
      </form>
    </div>
    <div class="absolute pin-b pin-r mr-4 mb-2">
      <div class="text-brand-dark text-sm">dengan <span class="text-red">♥</span> | Kemdikbud 2019</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  LOGIN
} from '@/mutationTypes'

export default {
  name: 'login',
  computed: {
    ...mapState(['loginStatus']),
    errorMessage () {
      let message
      switch (this.error) {
        case 'credentials':
          message = 'Periksa username dan password Anda.'
          break
        case 'network':
          message = 'Periksa koneksi internet Anda.'
          break
      }
      return message
    }
  },
  data () {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  methods: {
    async login () {
      let username = this.username
      let password = this.password
      let login = await this.$store.dispatch(LOGIN, { username, password })
      if (login.success) {
        this.$router.push('/')
      } else {
        this.error = login.error
      }
    }
  }
}
</script>
